module.exports = __webpack_public_path__ + "static/media/singblack.347a44f5.png";